module.exports = __webpack_public_path__ + "img/avatar-exercise-01.9df2ccd5.png";